import {useStaticQuery, graphql} from "gatsby"

export const GetList = () => {
    const {allMarkdownRemark} = useStaticQuery(
        graphql`
        query listJets {
            allMarkdownRemark(filter: {fields: {collection: {eq: "jets"}}}, sort: {order: ASC, fields: frontmatter___order}) {
                edges {
                  node {
                    frontmatter {
                      slug
                      title
                      pasajeros
                      equipaje
                      thumbnail {
                        childImageSharp {
                          fluid(maxWidth: 300) {
                                ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        `
    )
    return allMarkdownRemark.edges;
}
